import { Nursery } from './Nursery';
import { getNameWithCloserMatch } from '../helpers/search.helper';

class Product {
  active: number;
  category: string;
  category_type: string;
  created_at: string;
  cultivar: string;
  description: string;
  entered_by: number;
  featured_photo_url: string;
  featured_photo_thumb_url: string;
  genus: string;
  id: number;
  import_status: number;
  modified_by: number;
  name_common: string;
  name_scientific: string;
  product_type: string;
  species: string;
  status_id: number;
  subcategory: string;
  type_id: number;
  updated_at: string;

  locations: Nursery[];

  constructor(data: any) {
    this.active = data.active;
    this.category = data.category;
    this.category_type = data.category_type;
    this.created_at = data.created_at;
    this.cultivar = data.cultivar;
    this.description = data.description;
    this.entered_by = data.entered_by;
    this.featured_photo_url = data.featured_photo_url;
    this.featured_photo_thumb_url = data.featured_photo_thumb_url;
    this.genus = data.genus;
    this.id = data.id;
    this.import_status = data.import_status;
    this.modified_by = data.modified_by;
    this.name_common = data.name_common;
    this.name_scientific = data.name_scientific;
    this.species = data.species;
    this.status_id = data.status_id;
    this.subcategory = data.subcategory;
    this.type_id = data.type_id;
    this.updated_at = data.updated_at;

    this.locations = data.locations || [];
  }

  getCorrectProductNameToShow(search: string) {
    const nameArray = [
      this.name_common,
      this.name_scientific,
      this.genus,
    ];
    return getNameWithCloserMatch(nameArray, search);
  }

  getCorrectSecondProductNameToShow(search: string) {
    const nameArray = [
      this.name_common,
      this.name_scientific,
      this.genus,
    ];
    const closerMatch = getNameWithCloserMatch(nameArray, search);
    return closerMatch ? nameArray.filter((name => name != closerMatch))[0] : null;
  }

  getCategoryString() {
    return this.category_type + ' - ' + this.category + (this.subcategory ? ' - ' + this.subcategory : '');
  }
}

export { Product };
